import React, {Component} from 'react';
import $ from 'jquery';
import PageLoader from './loader';

class MainComponent extends Component {
    set(new_key, new_val) {
        let thisComponent = this;
        // console.log("Setting: " + new_key + ' ' + new_val);
        thisComponent.setState({
            new_key: new_val
        });
    }

    get(get_key) {
        // console.log("Getting key " + get_key);
        return this.state[get_key];
    }

    loadData(url_get, function_handler) {
        // return 'thats strange!!!';
        let thisComponent = this;
        $.ajax({
            url: url_get,
            type: 'GET',
            crossDomain: true,
            // async: true,
            // data: 'twitterUsername=jquery4u',
            success: function (data) {
                function_handler(thisComponent, data);
            },
            error: function (e) {
                console.log('error...');
                //called when there is an error
                //console.log(e.message);
            }
        });
    }

    noDataPreloader() {
        return (<PageLoader/>);
    }
}

export default MainComponent;



// WEBPACK FOOTER //
// ./src/components/MainComponent.js